//These are custom propriety functions that can be imported and used across the application
import { PLAN_EDIT_LIMITS } from "../model/global.data.library.js";

export const capitalizeFirstLetter = (tag) => {
  if (!tag || typeof tag !== "string") return "Untagged"; // handle empty/null
  return tag.charAt(0).toUpperCase() + tag.slice(1);
};

export const getPriorityLabel = (value) => {
  if (value >= 1 && value <= 3) return "Low";
  if (value >= 4 && value <= 6) return "Moderate";
  if (value >= 7 && value <= 10) return "High";
  return "Unknown";
};

export const getPriorityClass = (value) => {
  if (value >= 1 && value <= 3) return "priority-low";
  if (value >= 4 && value <= 6) return "priority-moderate";
  if (value >= 7 && value <= 10) return "priority-high";
  return "priority-unknown";
};

export const getStatusClass = (status) => {
  switch (status?.toLowerCase()) {
    case "not started":
      return "status-not-started";
    case "in progress":
      return "status-in-progress";
    case "on hold":
      return "status-hold";
    case "completed":
      return "status-completed";
    default:
      return "status-unknown";
  }
};

export const dateConverted = (dateInput) => {
  const date = new Date(dateInput);

  const legibleDate = date.toLocaleString([], {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return legibleDate;
};

//include / translate the sorting functions here
//as well as create tags functionality

export const getProjectLimit = (plan) => {
  return PLAN_EDIT_LIMITS[plan];
};
